// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore, executeAwaitableHandlerChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    UpdateCart,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetShippingMethod";
import loadWarehouses from "@steiner/App/Handlers/Checkout/LoadWarehouses";
import { WarehousesModel } from "@steiner/App/Services/CheckoutWarehouse";

const AddAdditionalData: typeof UpdateCart = async props => {
    /**
     * Steiner doesn't use Opti pickup logic.
     * Instead, if the selected carrier from checkout is "Will Call",
     * it uses it as the pickup location.
     * This ensures that the correct warehouse is set for will call orders.
     * Sending shipVia.id in cart.properties.willCallWarehouse
     * then BE will return willCallWarehouseAddress in the cart response
     */
    const isWillCall = props.apiParameter.cart.carrier?.description === "Will Call";
    const warehouseResult = await executeAwaitableHandlerChain<{}, WarehousesModel>(loadWarehouses, {}, props);
    if (!isWillCall) {
        return;
    }
    props.apiParameter = {
        ...props.apiParameter,
        cart: {
            ...props.apiParameter.cart,
            properties: {
                ...props.apiParameter.cart.properties,
                willCallWarehouse:
                    (props.parameter as { willCallWarehouseId?: string }).willCallWarehouseId ||
                    warehouseResult.warehouses?.[0].warehouseId,
            },
        },
    };
};

addToChainBefore(chain, UpdateCart, AddAdditionalData);
